import { FieldConfig } from '../../restaurant/models';
import { MergedCustomFields } from '../../party';

export function extractPartyFieldsFromCustomer(
  config: FieldConfig[],
  customer: MergedCustomFields,
): MergedCustomFields {
  const customFields: Record<string, unknown> = {};
  for (const fieldDefinition of config) {
    if (fieldDefinition.enabled && fieldDefinition.customer) {
      customFields[fieldDefinition.id] = customer.customFields[fieldDefinition.id];
    }
  }

  return {
    name: customer.name,
    customFields,
  };
}
